import { render, staticRenderFns } from "./CoozzyMinusIcon.vue?vue&type=template&id=0566c078&scoped=true"
import script from "./CoozzyMinusIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyMinusIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyMinusIcon.vue?vue&type=style&index=0&id=0566c078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0566c078",
  null
  
)

export default component.exports